<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 15.5H13V13.8333H8V15.5ZM5.5 9.66667V11.3333H15.5V9.66667H5.5ZM3 5.5V7.16667H18V5.5H3Z" />
</svg>
